export default "__VITE_ASSET__Nsu8PItA__"